export { ErrorComponent } from "./components/error/error.component";

export { AuthService } from "./services/auth.service";
export { AuthGuardService } from "./services/auth-guard.service";

export { Confrontation } from "./confrontation";


// WEBPACK FOOTER //
// ./src/app/shared/index.ts